import { GEWERK } from './gemeinsam';
import { DataTable, EmptyState, type Spalte } from '../../muster';

/** Pflichtbauteile — ein fehlendes Pflichtbauteil ist eine Aufgabe wie eine Kollision. */
export function Pflichtbauteile({ pflichtbauteile }: { pflichtbauteile: any[] }) {
  const spalten: Spalte<any>[] = [
    {
      schluessel: 'gewerk', titel: 'Gewerk', immerSichtbar: true, breite: '140px',
      wert: (p) => GEWERK[p.gewerk] ?? p.gewerk,
    },
    { schluessel: 'bauteil', titel: 'Bauteil', wert: (p) => p.bauteilart },
    {
      schluessel: 'bedingung', titel: 'Bedingung',
      wert: (p) => p.bedingung,
      inhalt: (p) => <span style={{ fontSize: 12 }}>{p.bedingung}</span>,
    },
    {
      schluessel: 'norm', titel: 'Norm', breite: '150px',
      wert: (p) => p.normbezug ?? '',
      inhalt: (p) => <span className="schwach">{p.normbezug ?? '—'}</span>,
    },
    {
      schluessel: 'einbaulaenge', titel: 'Einbaulänge', art: 'zahl', einheit: 'mm',
      nachkomma: 0, breite: '140px',
      wert: (p) => p.einbaulaengeMm,
    },
  ];

  return (
    <DataTable
      name="Pflichtbauteile"
      beschreibung={'Ein Bauteil, das erforderlich ist und fehlt, ist eine '
        + 'Koordinationsaufgabe wie eine Kollision. Die Pflichten stehen in einer '
        + 'Tabelle und nicht im Programm: Sie unterscheiden sich je Land, Bauordnung '
        + 'und Projekt.'}
      spalten={spalten}
      zeilen={pflichtbauteile ?? []}
      schluessel={(p) => `${p.gewerk}-${p.bauteilart}`}
      ausfuhr
      leer={(
        <EmptyState
          titel="Kein Pflichtbauteil hinterlegt."
          erklaerung={'Ohne Pflichtenliste meldet die Koordination kein fehlendes '
            + 'Bauteil — sie kann nicht wissen, was fehlt.'}
        />
      )}
    />
  );
}
